import Translate from "lang/Translate"

const CaseNoResults = () => {
  return (
    <div className="border-bottom p-4">
      <div className="case-list-header flex-center">
        <Translate text="Content.no_result" />
      </div>
    </div>
  )
}

export default CaseNoResults